var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgDocumentText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 19a2 2 0 01-2 2H7a2 2 0 01-2-2V5a2 2 0 012-2h5v4H8a1 1 0 000 2h4c.086 0 .17-.01.25-.031A2 2 0 0014 10h5v9zM13 7.5V3.483a.2.2 0 01.341-.142L18.66 8.66a.2.2 0 01-.142.341H14.5A1.5 1.5 0 0113 7.5zM8 12a1 1 0 100 2h8a1 1 0 100-2H8zm0 4a1 1 0 100 2h4a1 1 0 100-2H8z",
    fill: "currentColor"
  })));
}

export default SvgDocumentText;